import React from "react";
import Hero from "../components/HowItWorks/Hero";
import Banner from "../components/HowItWorks/Banner";
import Steps from "../components/HowItWorks/Steps";
import DonationBreakdown from "../components/HowItWorks/DonationBreakdown";
import MoreInformation from "../components/HowItWorks/MoreInformation";

const HowItWorksPage = () => {
  return (
    <div>
      <Hero />
      <Banner />
      <Steps />
      {/* <DonationBreakdown /> */}
      <MoreInformation />
    </div>
  );
};

export default HowItWorksPage;
